import { Component, OnInit, OnDestroy, NgZone, Inject, PLATFORM_ID } from '@angular/core';
import { CommonModule, isPlatformBrowser, isPlatformServer } from '@angular/common';
// ngrx store
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';

// service

// models
import { AppState } from '../../../booking/models/app-state.interface';
import { elementAt } from 'rxjs/operators';
import { FormsModule } from '@angular/forms';
import { updateLanguage } from '@shared/reducers/copy.reducer';

@Component({
  selector: 'app-language-selector',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.scss']
})
export class LanguageSelectorComponent implements OnInit, OnDestroy {

  private _userLanguageSubscription: Subscription;

  public selectedLanguage: string = '';
  public showLanguageMenu = false;

  constructor(
    private _appStore: Store<AppState>,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  ngOnInit() {

    if (isPlatformBrowser(this.platformId)) {

      this._userLanguageSubscription = this._appStore.select('copyReducer')
        .subscribe((res: any) => {
          this.selectedLanguage = res.languageCode
        });
    }
  }

  toggleLanguageMenu() {
    this.showLanguageMenu = !this.showLanguageMenu;
  }

  closeLanguageMenu() {
    this.showLanguageMenu = false;
  }

  languageChanged(e) {
    const language = e === 'en' ? '' : `_${e}`;
    localStorage.setItem('languageCode', e)
    this._appStore.dispatch(updateLanguage({ payload: { 'language': language, 'languageCode': e } }));
    this.showLanguageMenu = false;

    const customEvent = new CustomEvent('changeLanguage', {
      detail: {
        value: language
      }
    });
    localStorage.setItem('languageCode', e)
    window.dispatchEvent(customEvent);
  }

  ngOnDestroy() {


    if (this._userLanguageSubscription) { this._userLanguageSubscription.unsubscribe() }
  }

}
